export const CHECKOUT_URL =
  'https://checkout.activapleno.com/cart/44423392297075:1'
export const META_PIXEL_ID = '1225428543097695'

export const IMAGES = {
  tomo1:
    'https://cdn.magicpatterns.com/uploads/cGXj1uw7VHUfjQvTf99C5B/Tomo_1.png',
  tomo2:
    'https://cdn.magicpatterns.com/uploads/8eyyafLWDmVDr3vRq2Fsj7/Tomo_2.png',
  tomo3:
    'https://cdn.magicpatterns.com/uploads/472rmfPdAZFfTLgdCXsyxD/Tomo_3.png',
  tomo4:
    'https://cdn.magicpatterns.com/uploads/eiBVDZxMGBgopFrssxuXaY/Tomo_4.png',
  tomo5:
    'https://cdn.magicpatterns.com/uploads/hnnTzUViDQ4AYowYFhhKmM/Tomo_5.png',
}
